import PropTypes from 'prop-types';
import React from 'react';
import { bemComponent } from '@99designs/utils/app';

export const ContentListing = bemComponent('content-listing', 'ContentListing');
export const ContentListingItem = bemComponent('content-listing__item');
export const ContentListingItemImage = bemComponent('content-listing__item__image');
export const ContentListingItemDetailsActionsWrapper = bemComponent(
    'content-listing__item__details-actions'
);
export const ContentListingItemDetails = bemComponent(
    'content-listing__item__details-actions__details'
);

export class ContentListingItemActions extends React.Component {
    render() {
        return (
            <div className="content-listing__item__details-actions__actions">
                <div className="content-listing__item__details-actions__actions__inner">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

ContentListingItemActions.propTypes = {
    children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/content-listing.jsx